import React from 'react';
import { reduxForm, formValueSelector, change } from 'redux-form/immutable';
import StudentData from './NewStudentForm/StudentData'
import GuardianData from './NewStudentForm/GuardianData'
import { connect } from "react-redux";
import CurrentSchoolData from "./NewStudentForm/CurrentSchoolData";
import BrothersMembersData from "./NewStudentForm/BrothersMembersData";
import AccountInformationData from './NewStudentForm/AccountInformationData'
import SchoolBusData from './NewStudentForm/SchoolBusData'
import StudImg from "./NewStudentForm/StudImg";
import StudnetClub from "./NewStudentForm/StudnetClub";
import { fromJS } from 'immutable'
import { Alert, Button, Card, message } from 'antd'
import StudContact from "./NewStudentForm/StudContact";

// 樣式定義
const errorFieldStyle = {
  animation: 'errorPulse 1s'
};

const formFieldsetStyle = {
    border: 0,
    margin: 0,
    padding: 0,
    minWidth: 0,
};

class ApplicationForAdmissionForm extends React.Component {
    componentDidMount() {
        // 打印接收到的數據，用於調試
        console.log('ApplicationForAdmissionForm mounted, data:', this.props.initialValues);
    }

    render() {
        const { handleSubmit, isLocked, error, submitFailed, clubRuleStatus } = this.props;

        return (
            <form onSubmit={isLocked ? undefined : handleSubmit} noValidate>
                {isLocked && (
                    <Alert
                        type="warning"
                        showIcon
                        style={{ marginBottom: '16px' }}
                        message="此表單已由註冊組鎖定，請聯繫註冊組開啟後再修改。"
                    />
                )}
                <fieldset disabled={isLocked} style={formFieldsetStyle}>
                    <Card title="照片上傳說明">
                        <img alt="example" src="/images/ID-images.jpg" style={{ width: '100%', height: '100%' }} />
                    </Card>
                    <br />
                    <StudImg {...this.props} changStudImg={this.changStudImg} />
                    <br />
                    <StudentData />
                    <br />
                    <AccountInformationData />
                    <br />
                    <GuardianData changGuardianData={this.changGuardianData} />
                    <br />
                    <StudContact changStudContact={this.changStudContact}/>
                    <br />
                    <CurrentSchoolData />
                    <br />
                    <SchoolBusData />
                    <br />
                    <StudnetClub
                        validationError={submitFailed ? error : null}
                        ruleStatus={clubRuleStatus}
                    />
                    <br />

                    <BrothersMembersData />
                    <br />
                    {/*<FamilyMembersData />*/}
                </fieldset>
                <Button
                    htmlType="submit"
                    type={'primary'}
                    size={'large'}
                    disabled={isLocked}
                    style={{ width: '100%', marginTop: '10px' }}
                >
                    {isLocked ? '已鎖定' : '送出'}
                </Button>
                <br />
                <br />
                

            </form>
        )
    }

    changStudImg = (file) => {
        if (this.props.isLocked) {
            message.warning('此表單已鎖定，無法上傳照片');
            return;
        }

        if (file && file.length > 0) {
            // 為檔案建立一個臨時URL 
            const imageUrl = file[0].preview || URL.createObjectURL(file[0]);
            
            console.log('處理學生照片上傳 - 創建臨時URL:', imageUrl);
            
            // 設置臨時圖片URL到Redux表單，用於即時預覽
            this.props.changeFieldValue('stud_img_url', imageUrl);
            
            // 啟動上傳流程
            console.log('開始上傳學生照片');
            this.props.uploadStudImg(file);
        }
    }

    changGuardianData = (value) => {
        switch (value) {
            case 'moth':
                this.props.changeFieldValue('guardian_name', this.props.moth_name);
                this.props.changeFieldValue('guardian_phone', this.props.moth_phone);
                this.props.changeFieldValue('guardian_hand_phone', this.props.moth_hand_phone);
                this.props.changeFieldValue('guardian_occupation', this.props.moth_occupation);
                this.props.changeFieldValue('guardian_unit', this.props.moth_unit);
                this.props.changeFieldValue('guardian_work_name', this.props.moth_work_name);
                this.props.changeFieldValue('guardian_email', this.props.moth_email);
                break;
            case 'fath':
                this.props.changeFieldValue('guardian_name', this.props.fath_name);
                this.props.changeFieldValue('guardian_phone', this.props.fath_phone);
                this.props.changeFieldValue('guardian_hand_phone', this.props.fath_hand_phone);
                this.props.changeFieldValue('guardian_occupation', this.props.fath_occupation);
                this.props.changeFieldValue('guardian_unit', this.props.fath_unit);
                this.props.changeFieldValue('guardian_work_name', this.props.fath_work_name);
                this.props.changeFieldValue('guardian_email', this.props.fath_email);
                break;
            default:
        }
    }
    changStudContact= (value) => {
        switch (value) {
            case 'moth':
                this.props.changeFieldValue('contact_name', this.props.moth_name);
                this.props.changeFieldValue('contact_tel', this.props.moth_hand_phone);
                if (this.props.stud_sex === '1') {
                    this.props.changeFieldValue('contact_relationship', '母子');
                } else {
                    this.props.changeFieldValue('contact_relationship', '母女');
                }
                break;
            case 'fath':
                this.props.changeFieldValue('contact_name', this.props.fath_name);
                this.props.changeFieldValue('contact_tel', this.props.fath_hand_phone);
                if (this.props.stud_sex === '1') {
                    this.props.changeFieldValue('contact_relationship', '父子');
                } else {
                    this.props.changeFieldValue('contact_relationship', '父女');
                }
                break;
            default:
        }
    }
}

const clubRules = {
    club_monday: { afterSchool: '100', selfPickup: '138' },
    club_tuesday: { afterSchool: '200', selfPickup: '246' },
    club_wednesday: { afterSchool: '300', selfPickup: '339' },
    club_thursday: { afterSchool: '400', selfPickup: '434' },
    club_friday: { afterSchool: '500', selfPickup: '540' },
};
const clubReminderMessage = '貼心提醒：為讓孩子們能從容適應學習節奏、兼顧學習品質，每週社團活動請以三項為上限!! 至少 2 天必須選擇「安親」或「自接」，感謝您的支持與配合!';

const normalizeFieldValue = (values, key) => {
    if (!values || typeof values.get !== 'function') return '';
    const rawValue = values.get(key);
    if (rawValue === undefined || rawValue === null) return '';
    return rawValue.toString();
};

const validateClubRule = values => {
    let matchedDays = 0;
    Object.keys(clubRules).forEach((fieldKey) => {
        const selectedValue = normalizeFieldValue(values, fieldKey);
        const { afterSchool, selfPickup } = clubRules[fieldKey];
        if (selectedValue === afterSchool || selectedValue === selfPickup) {
            matchedDays += 1;
        }
    });

    if (matchedDays < 2) {
        return clubReminderMessage;
    }

    return null;
};

const toStringValue = value => {
    if (value === undefined || value === null) return '';
    return value.toString();
};

const buildClubRuleStatus = ({ club_monday, club_tuesday, club_wednesday, club_thursday, club_friday }) => {
    const values = [
        toStringValue(club_monday),
        toStringValue(club_tuesday),
        toStringValue(club_wednesday),
        toStringValue(club_thursday),
        toStringValue(club_friday),
    ];
    const expectedValues = [
        clubRules.club_monday.afterSchool, clubRules.club_monday.selfPickup,
        clubRules.club_tuesday.afterSchool, clubRules.club_tuesday.selfPickup,
        clubRules.club_wednesday.afterSchool, clubRules.club_wednesday.selfPickup,
        clubRules.club_thursday.afterSchool, clubRules.club_thursday.selfPickup,
        clubRules.club_friday.afterSchool, clubRules.club_friday.selfPickup,
    ];
    const matchCount = values.filter(value => expectedValues.indexOf(value) >= 0).length;
    const hasAnySelection = values.some(value => value !== '' && value !== '0' && value !== '-1');
    return {
        matchCount,
        hasAnySelection,
        isValid: matchCount >= 2,
    };
};


ApplicationForAdmissionForm = reduxForm({
    form: 'applicationForAdmission', // a unique identifier for this form
    enableReinitialize: true,
    validate: values => {
        const errors = {};
        const clubRuleError = validateClubRule(values);
        if (clubRuleError) {
            errors._error = clubRuleError;
        }
        return errors;
    },
    onSubmitFail: (errors, dispatch, submitError) => {
        console.log('表單提交失敗，錯誤欄位:', errors);
        
        // 顯示錯誤信息
        if (errors && errors._error) {
            message.error(errors._error);
        } else {
            message.error('表單有欄位未填寫或格式不正確，請檢查');
        }
        
        // 找到頁面上第一個錯誤欄位
        setTimeout(() => {
            const errorFields = document.querySelectorAll('.has-error');
            if (errorFields && errorFields.length > 0) {
                // 獲取第一個錯誤欄位
                const firstErrorField = errorFields[0];
                
                // 添加樣式使其更明顯
                firstErrorField.style.border = '2px solid red';
                firstErrorField.style.backgroundColor = 'rgba(255, 0, 0, 0.05)';
                
                // 滾動到錯誤欄位
                firstErrorField.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
                
                // 嘗試聚焦到該欄位
                const input = firstErrorField.querySelector('input, select, textarea');
                if (input) input.focus();
                
                // 3秒後恢復正常樣式
                setTimeout(() => {
                    firstErrorField.style.border = '';
                    firstErrorField.style.backgroundColor = '';
                }, 3000);
            }
        }, 100);
    }
})(ApplicationForAdmissionForm);
const selector = formValueSelector('applicationForAdmission');

const mapDispatchToPorps = (dispatch) => ({
    changeFieldValue: function (field, value) {
        dispatch(change('applicationForAdmission', field, value))
    },
})

// 簡化的獲取圖片URL的輔助函數
const getStudImgUrl = (data, localImgUrl) => {
    // 優先使用本地臨時URL（如blob或data URI，通常是最新上傳的）
    if (localImgUrl && typeof localImgUrl === 'string' && 
        (localImgUrl.startsWith('blob:') || localImgUrl.startsWith('data:'))) {
        console.log('getStudImgUrl: 使用本地臨時URL');
        return localImgUrl;
    }
    
    // 如果沒有數據，返回空
    if (!data) return '';
    
    // 其次使用stud_img（需要組合API_SERVER）
    if (data.stud_img && typeof data.stud_img === 'string') {
        // 如果已經是完整URL，直接返回
        if (data.stud_img.startsWith('http://') || data.stud_img.startsWith('https://')) {
            console.log('getStudImgUrl: stud_img已是完整URL');
            return data.stud_img;
        }
        
        // 組合API_SERVER和路徑
        const baseUrl = API_SERVER.endsWith('/') ? API_SERVER.slice(0, -1) : API_SERVER;
        const path = data.stud_img.startsWith('/') ? data.stud_img : `/${data.stud_img}`;
        const fullUrl = `${baseUrl}${path}`;
        console.log('getStudImgUrl: 組合API_SERVER與stud_img:', fullUrl);
        return fullUrl;
    }
    
    // 再次嘗試使用stud_img_url
    if (data.stud_img_url && typeof data.stud_img_url === 'string') {
        console.log('getStudImgUrl: 使用stud_img_url');
        return data.stud_img_url;
    }
    
    // 最後嘗試其他本地URL
    if (localImgUrl && typeof localImgUrl === 'string') {
        console.log('getStudImgUrl: 使用其他本地URL');
        return localImgUrl;
    }
    
    // 沒有找到有效的圖片
    return '';
};

ApplicationForAdmissionForm = connect(
    state => {
        // 取得圖片資訊
        const data = state.getIn(['ApplicationForAdmissionReducers', 'data']);
        const localImgUrl = selector(state, 'stud_img_url');
        
        // 安全地獲取值
        const safeData = data ? data.toJS ? data.toJS() : data : {};
        
        // 使用輔助函數獲取圖片URL
        const studImgUrl = getStudImgUrl(safeData, localImgUrl);
        console.log('計算出的studImgUrl:', studImgUrl);
        console.log('stud_img值:', safeData.stud_img);
        
        return {
            initialValues: fromJS(safeData),
            isLocked: !!safeData.ques_check,
            studImgValue: studImgUrl,
            stud_img: safeData.stud_img || null,
            moth_name: selector(state, 'moth_name'),
            moth_phone: selector(state, 'moth_phone'),
            moth_hand_phone: selector(state, 'moth_hand_phone'),
            moth_occupation: selector(state, 'moth_occupation'),
            moth_unit: selector(state, 'moth_unit'),
            moth_work_name: selector(state, 'moth_work_name'),
            moth_email: selector(state, 'moth_email'),

            fath_name: selector(state, 'fath_name'),
            fath_phone: selector(state, 'fath_phone'),
            fath_hand_phone: selector(state, 'fath_hand_phone'),
            fath_occupation: selector(state, 'fath_occupation'),
            fath_unit: selector(state, 'fath_unit'),
            fath_work_name: selector(state, 'fath_work_name'),
            fath_email: selector(state, 'fath_email'),
            fath_person_id: selector(state, 'fath_person_id'),
            moth_person_id: selector(state, 'moth_person_id'),
            contact_name: selector(state, 'contact_name'),
            contact_relationship: selector(state, 'contact_relationship'),
            contact_tel: selector(state, 'contact_tel'),
            clubRuleStatus: buildClubRuleStatus({
                club_monday: selector(state, 'club_monday'),
                club_tuesday: selector(state, 'club_tuesday'),
                club_wednesday: selector(state, 'club_wednesday'),
                club_thursday: selector(state, 'club_thursday'),
                club_friday: selector(state, 'club_friday'),
            }),
        }
    }
    , mapDispatchToPorps)(ApplicationForAdmissionForm)


export default (ApplicationForAdmissionForm)



// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/ApplicationForAdmissionContaioner/ApplicationForAdmissionForm.jsx